import NameDisplay from "components/ui/NameDisplay";
import React from "react";
import { EmptyContent } from "widgets/table/table-content/EmptyContent";

interface ReporterDataDisplayProps {
  notifierFamilyname: string | null | undefined;
  notifierForename: string | null | undefined;
  notifierMiddlename: string | null | undefined;
}

const ReporterDataDisplay: React.FC<ReporterDataDisplayProps> = ({
  notifierFamilyname,
  notifierForename,
  notifierMiddlename,
}) => {
  return (
    <>
      {(notifierFamilyname || notifierForename || notifierMiddlename) && (
        <span>
          <NameDisplay
            value={{
              familyname: notifierFamilyname,
              forename: notifierForename,
              middlename: notifierMiddlename,
            }}
          />
        </span>
      )}

      {!(notifierFamilyname || notifierForename || notifierMiddlename) && (
        <EmptyContent />
      )}
    </>
  );
};

export default ReporterDataDisplay;
